import { Mail, Phone } from "lucide-react";
import { CONTACT, whatsappLink } from "@/config/site";
import { LeadForm } from "@/components/LeadForm";

export const Contatti = () => (
  <section id="contatti" className="bg-warm py-20 lg:py-28" data-testid="contatti-section">
    <div id="richiedi-consulenza" className="container-ph grid gap-12 lg:grid-cols-12 lg:gap-16">
      <div className="lg:col-span-7">
        <div className="reveal">
          <span className="gold-line mb-5" />
          <h2 className="h-section">Raccontaci il tuo progetto</h2>
        </div>
        <div className="reveal reveal-delay-1 mt-10"><LeadForm /></div>
      </div>

      <aside className="reveal reveal-delay-2 lg:col-span-5 lg:pl-8 lg:border-l border-ivory-dark" data-testid="contatti-aside">
        <h3 className="font-serif text-2xl sm:text-3xl text-forest">Contattaci per informazioni</h3>
        <ul className="mt-8 space-y-6">
          {CONTACT.email && (
            <li className="flex items-start gap-4">
              <Mail size={20} strokeWidth={1.5} className="mt-0.5 text-bronze shrink-0" />
              <div><p className="eyebrow">Email</p><a href={`mailto:${CONTACT.email}`} className="mt-1 block text-forest hover:text-bronze transition-colors break-all" data-testid="contact-email-link">{CONTACT.email}</a></div>
            </li>
          )}
          {CONTACT.phone && (
            <li className="flex items-start gap-4">
              <Phone size={20} strokeWidth={1.5} className="mt-0.5 text-bronze shrink-0" />
              <div><p className="eyebrow">Telefono</p><a href={`tel:${CONTACT.phone.replace(/\s/g, "")}`} className="mt-1 block text-forest hover:text-bronze transition-colors" data-testid="contact-phone-link">{CONTACT.phone}</a></div>
            </li>
          )}
          {whatsappLink && (
            <li className="flex items-start gap-4">
              <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor" className="mt-0.5 text-bronze shrink-0" aria-hidden="true"><path d="M17.5 14.4c-.3-.1-1.8-.9-2-1-.3-.1-.5-.1-.7.1-.2.3-.8 1-.9 1.2-.2.2-.3.2-.6.1-.3-.1-1.3-.5-2.4-1.5-.9-.8-1.5-1.8-1.7-2.1-.2-.3 0-.5.1-.6l.4-.5c.1-.2.2-.3.3-.5.1-.2 0-.4 0-.5-.1-.2-.7-1.6-.9-2.2-.2-.6-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4-.3.3-1 1-1 2.5s1.1 2.9 1.2 3.1c.1.2 2.1 3.2 5.1 4.5.7.3 1.3.5 1.7.6.7.2 1.4.2 1.9.1.6-.1 1.8-.7 2-1.4.2-.7.2-1.3.2-1.4-.1-.2-.3-.3-.6-.4zM12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2zm0 18.2c-1.5 0-3-.4-4.3-1.2l-.3-.2-3 .8.8-2.9-.2-.3A8.2 8.2 0 1 1 12 20.2z" /></svg>
              <div>
                <p className="eyebrow">WhatsApp</p>
                <p className="mt-1 text-forest" data-testid="contact-whatsapp-number">{CONTACT.whatsapp}</p>
                <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="btn-outline mt-4 !py-2.5 !px-5" data-testid="contact-whatsapp-button">Scrivici su WhatsApp</a>
              </div>
            </li>
          )}
        </ul>
      </aside>
    </div>
  </section>
);
